import { handleFreeShipping } from '../global'
import { _t, isMobile } from '../base.js'

export function initStep1() {
    if ($('.id--9').length || $('.id--1').length) {
        step1ContentLoaded()
        document.addEventListener('ShoptetDOMCartContentLoaded', step1ContentLoaded)
    }
}

function addEmptyCartTexts() {
    const cartHeading = document.querySelector('.cart-heading')

    if (cartHeading) {
        const messageWrapper = document.createElement('div')
        messageWrapper.classList.add('empty-cart-wrapper')

        const message = document.createElement('p')
        message.textContent = _t('emptyCartText')

        const shopButton = document.createElement('a')
        shopButton.href = '/produkty/'
        shopButton.classList.add('btn', 'btn-lg', 'btn-conversion')
        shopButton.textContent = _t('startShopping')

        messageWrapper.appendChild(message)
        messageWrapper.appendChild(shopButton)

        cartHeading.parentNode.insertBefore(messageWrapper, cartHeading.nextSibling)
    }
}

function moveStepOneElements() {
    const summaryRow = document.querySelector('.row.summary')
    const nextStep = document.querySelector('.next-step.next-step--cart')
    const cartTable = document.querySelector('.cart-table tbody')
    const discountHeading = document.querySelector('h4')
    const discountCoupon = document.querySelector('.discount-coupon')

    if (summaryRow && nextStep && cartTable) {
        const cartWrapper = document.createElement('div')
        cartWrapper.classList.add('cart-wrapper')

        const heading = document.createElement('h3')

        cartWrapper.appendChild(heading)
        cartWrapper.appendChild(summaryRow)
        cartWrapper.appendChild(nextStep)

        cartTable.parentNode.insertBefore(cartWrapper, cartTable.nextSibling)

        if (cartTable && discountHeading && discountCoupon) {
            cartTable.appendChild(discountHeading)
            cartTable.appendChild(discountCoupon)
        }
    }

    $('.discounts-wrap').appendTo('.cart-table table')
    $('.discount-coupon').insertAfter('.discounts-wrap')
    $('.cart-table tbody h4').css('display', 'block').text(_t('discountCoupon')).prependTo('.discount-coupon')

    $('.discounts-wrap').appendTo('.cart-table tbody')
    $(`<h4 class="free-gift-heading">${_t('giftsHeading')}</h4>`).prependTo('.discounts-wrap')

    if (isMobile()) {
        $('.discount-coupon').insertAfter('.discounts-wrap')
    }
}

function renameStep1Texts() {
    const heading = document.querySelector('h3')
    const orderButton = document.querySelector('.next-step-forward .order-button-text')
    const cartHeading = document.querySelector('.cart-inner h4')
    const couponButton = document.querySelector(
        ".discount-coupon button[data-testid='buttonSubmitDiscountCoupon']"
    )

    if (heading) {
        heading.textContent = _t('orderSummary')
    }

    if (orderButton) {
        orderButton.textContent = _t('shippingAndPayment')
    }

    // if (cartHeading) {
    //     cartHeading.textContent = _t('discountCoupon')
    // }

    if (couponButton) {
        couponButton.textContent = _t('applyDiscount')
    }
}

// function addItemIdStep1() {
//     document.querySelectorAll('.removeable[data-micro-sku]').forEach((cartItem) => {
//         const skuValue = cartItem.getAttribute('data-micro-sku')
//         const mainLink = cartItem.querySelector('.main-link')

//         if (skuValue && mainLink) {
//             const skuDiv = document.createElement('div')
//             skuDiv.classList.add('cart-item-id')
//             skuDiv.textContent = `Kód produktu: ${skuValue}`

//             mainLink.insertAdjacentElement('afterend', skuDiv)
//         }
//     })
// }

function step1ContentLoaded() {
    addEmptyCartTexts()
    moveStepOneElements()
    renameStep1Texts()
    // addItemIdStep1();
    handleFreeShipping()
    console.log('cart 1')
}
